import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import "./app.vue?vue&type=style&index=0&id=5bf17d4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf17d4c"]])

export default __exports__